import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: 'simple-layout.component.html',
})
export class SimpleLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void { }
}



// WEBPACK FOOTER //
// /jenkins/jenkins/workspace/apppronosticos_install_s3_dev/src/app/layouts/simple-layout/simple-layout.component.ts